import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createSubcategoryProduct, editSubcategoryProduct, SeeSubCategories, SeeSubCategoriesById } from '../../../../actions/subCategoriesActions'
import CategoryDetaillView from '../../../../containers/Inventory/Products/Categories/CategoryDetaill/CategoryDetaill'

const CategoryDetaill = ({match}) => {
    const dispatch = useDispatch()
    const { isLoadingSubCategoriesList, subCategoriesList } = useSelector(state => state.subCategoriesAdmin)
    useEffect(() => {
        dispatch(SeeSubCategoriesById(match.params.idCategory))
       // dispatch(getproductc)
      return () => {
        
      }
    }, [match.params.idCategory])
    const [isEdit, setIsEdit] = useState(false)
    const formik = useFormik({
      initialValues:{
        name:""
      },
      onSubmit:(values)=>{
        if(isEdit){
          dispatch(editSubcategoryProduct(values.name,match.params.idCategory,values.id,()=>formik.resetForm()))
        }else{
          dispatch(createSubcategoryProduct(values.name,match.params.idCategory,()=>formik.resetForm()))
        }
  
      }
    })
  return (
    <CategoryDetaillView subCategories ={subCategoriesList}  isEdit={isEdit} formik={formik} setIsEdit={setIsEdit}/>
  )
}

export default CategoryDetaill